import React, { useContext } from 'react'
import LockOutlined from '@mui/icons-material/LockOutlined'

import Button from 'components/Form/Button'
import { CoreContext } from 'context/CoreContext'
import useI18n from 'hooks/useI18n'
import Wrapper from '../Wrapper'
import { Actions, IconShell, Message, Title } from './styled'

export default function ModalExclusiveContent() {
  const { setModal } = useContext(CoreContext)
  const { t } = useI18n()

  return (
    <Wrapper>
      <IconShell><LockOutlined /></IconShell>
      <Title>{t('exclusive_content_title')}</Title>
      <Message>{t('exclusive_content_message')}</Message>
      <Actions>
        <Button color="blue" width="fit-content" onClick={() => setModal(null)}>{t('continue_browsing')}</Button>
      </Actions>
    </Wrapper>
  )
}
